export default __webpack_public_path__ + "static/media/MozzarellaGarlicBread.c0db759d.jpg";